import { Facebook, Instagram, Twitter, Linkedin, Youtube, ExternalLink } from "lucide-react";

interface LandingSocialSectionProps {
  content?: any;
  theme?: any;
  businessInfo?: any;
  location?: any;
  workspace?: any;
  onTrackSocialClick?: (platform: string, url: string) => void;
}

const LandingSocialSection = ({
  content,
  theme,
  businessInfo,
  location,
  workspace,
  onTrackSocialClick
}: LandingSocialSectionProps) => {
  const socialPlatforms = [
    {
      name: 'Facebook',
      icon: Facebook,
      url: workspace?.facebook_url,
      color: '#1877F2'
    },
    {
      name: 'Instagram',
      icon: Instagram,
      url: workspace?.instagram_url,
      color: '#E4405F'
    },
    {
      name: 'Twitter',
      icon: Twitter,
      url: workspace?.twitter_url,
      color: '#1DA1F2'
    },
    {
      name: 'LinkedIn',
      icon: Linkedin,
      url: workspace?.linkedin_url,
      color: '#0077B5'
    },
    {
      name: 'YouTube',
      icon: Youtube,
      url: workspace?.youtube_url,
      color: '#FF0000'
    }
  ];

  const activePlatforms = socialPlatforms.filter(platform => platform.url);

  if (activePlatforms.length === 0) {
    return null;
  }

  return (
    <section id="social" className="py-16 lg:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ color: "var(--primary)" }}
          >
            {content?.heading || content?.title || "Connect With Us"}
          </h2>
          <div className="w-24 h-1 mx-auto" style={{ backgroundColor: "var(--primary)" }} />
          <p className="mt-6 text-lg text-gray-600 max-w-2xl mx-auto">
            {content?.description || content?.subtitle || "Follow us on social media for updates, tips, and exclusive offers"}
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6">
          {activePlatforms.map((platform) => {
            const Icon = platform.icon;
            return (
              <a
                key={platform.name}
                href={platform.url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => onTrackSocialClick?.(platform.name, platform.url)}
                className="w-16 h-16 rounded-full flex items-center justify-center transition-all hover:scale-110"
                style={{ backgroundColor: "color-mix(in srgb, var(--primary) 20%, transparent)" }}
              >
                <Icon className="h-8 w-8" style={{ color: "var(--primary)" }} />
              </a>
            );
          })}
        </div>

        {content?.customMessage && (
          <div className="mt-8 text-center">
            <p className="text-gray-600">{content.customMessage}</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default LandingSocialSection;